export const GET_BOOKS = "GET_BOOKS";
export const SET_BOOKS = "SET_BOOKS";

export const GET_MAIN_CHARACTERS = "GET_MAIN_CHARACTERS";
export const SET_MAIN_CHARACTERS = "SET_MAIN_CHARACTERS";

export const GET_GREAT_HOUSES = "GET_GREAT_HOUSES";
export const SET_GREAT_HOUSES = "SET_GREAT_HOUSES";
